// Push no aparelho (navegador instalado ou não): chave pública VAPID e assinaturas da pessoa.
import { z } from 'zod';
import { NOTIFICACAO_TIPOS } from './app';

export const PushChaveResponse = z.object({ chavePublica: z.string().nullable() });

export const PushAssinaturaInput = z.object({
  endpoint: z.string().url().max(2000),
  keys: z.object({ p256dh: z.string().min(10).max(300), auth: z.string().min(10).max(100) }),
  tipos: z.array(z.enum(NOTIFICACAO_TIPOS)).max(4).optional(),
  aparelho: z.string().trim().max(120).nullable().default(null),
});
export const PushAssinatura = z.object({
  id: z.string().uuid(),
  endpoint: z.string(),
  tipos: z.array(z.enum(NOTIFICACAO_TIPOS)),
  aparelho: z.string().nullable(),
  criadoEm: z.string(),
  ultimoEnvioEm: z.string().nullable(),
});
export const PushAssinaturasResponse = z.object({ itens: z.array(PushAssinatura) });
export const PushRemoverInput = z.object({ endpoint: z.string().url().max(2000) });
